import React, { useEffect, useState } from 'react';
import { Dialog, Form, Input, Textarea } from 'tdesign-react';
import Text from '@/components/Text';
import { createTenant } from '@/services/tenantService';
import formRulePattern from '@/utils/formRulePattern';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';
import { deal70101 } from '@/utils/common';

const { FormItem } = Form;

export default function FormModal({ handleClose, visible, clusterName, ...others }) {
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();

  const confirmBtn = useDisableButton({ loading: submitting, content: '确定' });

  useEffect(() => {
    if (visible) {
      form.reset();
    }
  }, [visible, form]);

  const doClose = () => handleClose();

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      setSubmitting(true);
      try {
        const { meta } = await createTenant(fields);
        // 主集群创建的资源已在灾备集群存在
        if (meta.code === 70101) {
          deal70101(meta.publicMessage, () => handleSubmit({ validateResult, fields }), {
            url: '/cluster/tenant/list',
            tenant: fields.tenant,
          });
          return;
        }

        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Dialog
      header='创建租户'
      onCancel={doClose}
      onConfirm={() => form.submit()}
      confirmBtn={confirmBtn}
      onCloseBtnClick={doClose}
      onEscKeydown={doClose}
      visible={visible}
      width={550}
      {...others}
    >
      <Form
        onSubmit={handleSubmit}
        form={form}
        initialData={{ clusterName }}
        resetType='initial'
        style={{ width: '80%', paddingBottom: 10 }}
      >
        <FormItem label='集群名称' name='clusterName'>
          <Text />
        </FormItem>
        <FormItem
          rules={[{ required: true }, formRulePattern('name')]}
          name='tenant'
          label='Tenant'
        >
          <Input placeholder='请输入' />
        </FormItem>
        <FormItem name='createUser' label='负责人'>
          <Input placeholder='请输入' />
        </FormItem>
        <FormItem name='app' label='应用'>
          <Input placeholder='请输入' />
        </FormItem>
        {/* <FormItem name='label' label='标签'> */}
        {/*  <Input placeholder='请输入' /> */}
        {/* </FormItem> */}
        <FormItem name='note' label='备注'>
          <Textarea placeholder='请输入' />
        </FormItem>
      </Form>
    </Dialog>
  );
}
